export default "__VITE_ASSET__JG70brcW__"